module.exports = __webpack_public_path__ + "static/placeholder-square-77b8b1103c94f8fe72087d37de2fb377.png";